"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _colors = require("HubStyleTokens/colors");

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Tabs = _interopRequireDefault(require("./Tabs"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _reactRouterDom = require("react-router-dom");

var _responsiveBreakpoints = _interopRequireDefault(require("../utils/responsiveBreakpoints"));

var _CovidRemoteSalesToolsBanner = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/CovidRemoteSalesToolsBanner"));

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: absolute;\n  z-index: -100;\n  background-color: #00bda5;\n  background-image: linear-gradient(\n    -303deg,\n    ", ",\n    0%,\n    #00afb2 56%,\n    ", " 100%\n  );\n  width: 100%;\n  height: 100%;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    text-align: left;\n    padding: 0 15px;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  text-align: center;\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    font-size: 16px;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 14px;\n  color: ", ";\n  .pricing-page-subtitle-link {\n    text-decoration: underline;\n    color: ", ";\n  }\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    font-size: 34px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 28px;\n  color: ", ";\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var PricingPageTitle = _styledComponents.default.h1.withConfig({
  displayName: "TabLayout__PricingPageTitle",
  componentId: "sc-1794ddg-0"
})(_templateObject(), _colors.OLAF, _responsiveBreakpoints.default.tablet(_templateObject2()));

var PricingPageSubtitle = _styledComponents.default.p.withConfig({
  displayName: "TabLayout__PricingPageSubtitle",
  componentId: "sc-1794ddg-1"
})(_templateObject3(), _colors.OLAF, _colors.OLAF, _responsiveBreakpoints.default.tablet(_templateObject4()));

var HeaderTitle = _styledComponents.default.div.withConfig({
  displayName: "TabLayout__HeaderTitle",
  componentId: "sc-1794ddg-2"
})(_templateObject5(), _responsiveBreakpoints.default.phone(_templateObject6()));

var HeaderGradient = _styledComponents.default.div.withConfig({
  displayName: "TabLayout__HeaderGradient",
  componentId: "sc-1794ddg-3"
})(_templateObject7(), _colors.CALYPSO, _colors.OZ);

var HeaderLink = function HeaderLink(_ref) {
  var history = _ref.history,
      children = _ref.children;
  return _react.default.createElement(_UILink.default, {
    className: "pricing-page-subtitle-link",
    onClick: function onClick() {
      history.push('/crm');
    }
  }, children);
};

HeaderLink = (0, _reactRouterDom.withRouter)(HeaderLink);

function HeaderBackdrop() {
  return _react.default.createElement("span", null, _react.default.createElement(_CovidRemoteSalesToolsBanner.default, null), _react.default.createElement(HeaderGradient, null), _react.default.createElement(HeaderTitle, {
    className: "m-auto-y-0"
  }, _react.default.createElement(PricingPageTitle, {
    className: "p-top-8 p-bottom-2 m-bottom-0"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.title"
  })), _react.default.createElement(PricingPageSubtitle, {
    className: "p-bottom-8 m-bottom-0"
  }, _react.default.createElement(_FormattedJSXMessage.default, {
    elements: {
      HeaderLink: HeaderLink
    },
    message: "pricingPage.subTitle_jsx"
  }))));
}

function TabLayout(_ref2) {
  var selectedPrimaryTab = _ref2.selectedPrimaryTab,
      selectedSecondaryTab = _ref2.selectedSecondaryTab,
      children = _ref2.children;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(HeaderBackdrop, null), _react.default.createElement(_Tabs.default, {
    selectedPrimaryTab: selectedPrimaryTab,
    selectedSecondaryTab: selectedSecondaryTab
  }), children);
}

var _default = TabLayout;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/TabLayout.js
// module id = 151
// module chunks = 5 6